import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./footer.scss";

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer py-3 mt-4">
        <div className="container">
          <div className="row">
            <div className="col">
              <strong className="logo-footer">
                <img
                  src="images/lkn-by-ppc-w.png"
                  alt="Digital kiosk by ProPress"
                  className="img img-fluid footer-logo"
                />
              </strong>
              {/* <div className="block-social">
                <div className="block-content">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/Agence-ProPress-Conseil-1372481299509640/?ref=bookmarks"
                  >
                    <i className="fab fa-facebook fa-2x" aria-hidden="true" />
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/company-beta/10984535/"
                  >
                    <i className="fab fa-linkedin fa-2x" aria-hidden="true" />
                  </a>
                </div>
              </div> */}
              
            </div>
            <div className="col">
              <ul className="list list-unstyled">
                <li>ProPress Conseil © 2016.</li>
                 <li>15 rue Claude Tillier, 75012 Paris</li>
                <li>+33 (0)1 53 27 34 00</li>
              </ul>
            </div>
            <div className="col">
               <ul className="list list-unstyled">
                <li>
                  <a href="https://cgu.kioskpress.fr" target="_blank"  rel="noopener noreferrer">{"Mentions légales"}</a>
                </li>
                <li>
                  <Link to="/contact">{"Nous écrire"}</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
